import { Box, Grid, Paper } from '@mui/material';
import React, { useEffect } from 'react';
import CustomDialog from '../../../sharedcomponents/dialog/dialog';
import { makeStyles } from '@mui/styles';
import ButtonContainer from '../../../sharedcomponents/buttoncontainer/buttonContainer';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import TextField from '@mui/material/TextField';
import { createState, useState, Downgraded } from '@hookstate/core';
import CustomizedSnackbars from '../../../sharedcomponents/snackbar/snackBar';
import moment from 'moment';
import Stack from '@mui/material/Stack';
import Helper from '../../../utility/helper';
import MUIDatePicker from '../../../sharedcomponents/datePicker';

const useStyles = makeStyles({
    iconContent: {
        display: 'flex',
        justifyContent: 'center',
    },
    boxContent: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        padding: '8px',
    },
    iconBoxContent: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        alignItems: 'center',
    },
    radioContent: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
});



const CreateDateTimeLocation = (props) =>
{
    const classes = useStyles();
    const createDateTime = createState({
        dropoffDate: props.handlePickupDate != undefined ? props.handlePickupDate : new Date(),
        dropoffAddress: '',
        id: '',
        pickupTime: null
    })
    const state = useState(createDateTime)
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });

    useEffect(() =>
    {
        state.set({
            dropoffDate: props.handlePickupDate != undefined ? props.handlePickupDate : new Date(),
            dropoffAddress: '',
            id: -1
        })

        if (props.handleData != null)
        {
            state.set({
                dropoffDate: props.handleData.date, dropoffAddress: props.handleData.address, id: props.handleData.id,
                pickupTime: Helper.FormatTime24(props.handleData.date)
            })
        }
    }, [props])


    const renderDialogContent = () =>
    {
        return (
            <Box>
                <Box className={classes.boxContent}>
                    <Paper elevation={0}>
                        <Grid container spacing={2} >
                            <Grid item md={4} xs={12}>
                            <MUIDatePicker
                            label="Drop Off Date"
                            value={state.dropoffDate.attach(Downgraded).get()}
                            error={false}
                            setValue={(newValue) =>
                                state.dropoffDate.set(newValue)}
                            disablePast={props.draftTransportID > 0 ? false : true}
                            
                        />
                                {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DatePicker
                                        label="Drop Off Date"
                                        value={state.dropoffDate.attach(Downgraded).get()}
                                        allowKeyboardControl={false}
                                        inputProps={{ readOnly: true }}
                                        // minDate={props.draftTransportID > 0 ? null : (props.handlePickupDate != undefined ? new Date(props.handlePickupDate) : ( new Date())}
                                        defaultValue={props.handlePickupDate != undefined ? new Date(props.handlePickupDate) : new Date()}
                                        disablePast={props.draftTransportID > 0 ? false : true}
                                        onChange={(newValue) =>
                                            state.dropoffDate.set(newValue)
                                        }
                                        renderInput={(params) => (
                                            <TextField {...params}
                                                onKeyDown={(e) =>
                                                    e.preventDefault()
                                                } size='small' />
                                        )}
                                    />
                                </LocalizationProvider> */}
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Stack noValidate spacing={2}>

                                    <TextField
                                        required
                                        id="time"
                                        label="Time"
                                        type="time"
                                        size="small"
                                        value={state.pickupTime
                                            .attach(Downgraded)
                                            .get()}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        inputProps={{
                                            step: 300, // 5 min
                                        }}
                                        onChange={(e) =>
                                        {
                                            state.pickupTime.set(e.target.value)
                                            // handleDisableBtn()
                                        }}
                                        sx={{ width: 150 }}
                                    // error={
                                    //     endTimeErr.length > 0
                                    //         ? true
                                    //         : false
                                    // }
                                    // helperText={endTimeErr}

                                    />

                                </Stack>
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <TextField
                                    size='small'
                                    required
                                    id="outlined-required"
                                    label="Dropoff Location"
                                    value={state.dropoffAddress.get()}
                                    onChange={(e) =>
                                        state.dropoffAddress.set(e.target.value)
                                    }
                                    multiline={true}
                                    minRows={3}
                                    maxRows={10}
                                    inputProps={{ maxLength: 260 }}

                                />
                            </Grid>
                        </Grid>

                    </Paper>

                </Box>
                {snackBarProps.openSnack && (
                    <CustomizedSnackbars
                        {...snackBarProps}
                        onClose={() =>
                            setSnackBarProps({ ...snackBarProps, openSnack: false })
                        }></CustomizedSnackbars>
                )}
            </Box>
        );
    };

    const handleClick = () =>
    {
        const dropoffDatetime = `${state.dropoffDate.get()}T${state.pickupTime.get()}:00`
        // console.log('dropoff address', state.dropoffAddress.get())
        if (moment(state.dropoffDate.attach(Downgraded).get()).isValid() == false)
        {
            setSnackBarProps({ ...snackBarProps, openSnack: true, variant: 'error', message: 'Please Select valid Date & Time' });
        } else if (moment(dropoffDatetime).isBefore(props.handlePickupDate))
        {
            setSnackBarProps({ ...snackBarProps, openSnack: true, variant: 'error', message: 'Please Select valid Date & Time' });

        }
        else if (!state.pickupTime.get() || state.dropoffAddress.get() == null)
        {
            setSnackBarProps({ ...snackBarProps, openSnack: true, variant: 'error', message: 'Please select Dropoff Time' });
        } else if (!state.dropoffAddress.get() || state.dropoffAddress.get() == null)
        {
            setSnackBarProps({ ...snackBarProps, openSnack: true, variant: 'error', message: 'Please enter Dropoff Location' });
        } else
        {
            const date = Helper.FormatDateOnly(state.dropoffDate.attach(Downgraded).get()).split("T")
            const dateTime = `${date[0]}T${state.pickupTime.get()}:00`
            props.handleAction(dateTime, state.dropoffAddress.get(), state.id.get(), state.pickupTime.get());
            props.getPrevInfo()
        }

    }

    const renderDialogActions = () =>
    {
        return (
            <ButtonContainer
                handleClick={handleClick}
                handleCancel={props.handleClose}
                buttonText={props.handleData != null ? 'Update' : 'Create'}
            />
        );
    };

    return (
        <CustomDialog
            title={props.title}
            handleClose={props.handleClose}
            open={props.open}
            fullWidth={true}
            // maxWidth={'sm'}
            // title={'Export Itinerary'}
            renderContent={renderDialogContent}
            renderActions={renderDialogActions}
        />
    );
};

export default CreateDateTimeLocation;
